import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=5b56315e&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=5b56315e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56315e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b56315e')) {
      api.createRecord('5b56315e', component.options)
    } else {
      api.reload('5b56315e', component.options)
    }
    module.hot.accept("./userDetails.vue?vue&type=template&id=5b56315e&scoped=true", function () {
      api.rerender('5b56315e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/user/userDetails.vue"
export default component.exports